<template>
  <div>
    <v-container class="mt-2">
      <v-row>
        <v-col>
          <div class="v-input theme--light mb-4" >
            <v-btn v-if="jobButton" @click="sendJob" outlined color="primary">
              <i aria-hidden="true" class="v-icon notranslate material-icons theme--light">refresh</i>
              {{ $t('display/logs:elevator-day.calculate-sum') }}
            </v-btn>
            <v-btn-toggle
              mandatory
              dense
              class="ml-4"
              v-model="model">
              <v-btn>
                <i aria-hidden="true" class="v-icon notranslate material-icons theme--light">remove</i>
              </v-btn>
              <v-btn>
                <i aria-hidden="true" class="v-icon notranslate material-icons theme--light">add</i>
              </v-btn>
            </v-btn-toggle>
            <div class="ml-3">{{ $t('display/logs:advert.limit-24hours') }}</div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "TablePanel",
  props: {
    filterValue: Boolean,
    jobButton: Boolean,
    jobText: String
  },
  data() {
    return {
      model: 0,
      oldModel: 0 //previous model value to compare if value changed
    }
  },
  methods: {
    customPanelUpdated(fieldName, fieldValue) {
      this.$emit('customPanelValueUpdated', fieldName, fieldValue);
    },
    sendJob() {
      this.$emit('sendJob');
    }
  },
  watch: {
    model() {
      let value = this.model === 1 ? true : false;

      //only emit info if value of the model really changed
      //there must be something else going on, as watch should only trigger if this value gets updated anyway
      //however currently gets triggered twice if model value changes to 1
      if(this.model != this.oldModel) {
        this.oldModel = this.model
        this.$emit('customPanelValueUpdated', value);
      }
    }
  },
  created() {
    this.model = this.filterValue === true ? 1 : 0;
    this.oldModel = this.model
  }

}
</script>
